import { useState } from "react";
import User from "../passapp-sdk/user";
import { useStore } from "./useStore";

interface DialogProviderAuthorization {
  open: boolean;
  providers: any[];
  lotName: string;
  selection?: any;
}

const useProviderAuthorization = () => {
  const user = new User();
  const [loading, setLoading] = useState(false);
  const { authStore } = useStore();
  const [dialogState, setDialogState] = useState<DialogProviderAuthorization>({
    open: false,
    lotName: "",
    providers: [],
  });

  const reset = () => {
    setDialogState({ open: false, lotName: "", providers: [] });
  };

  type ProfessionTypeProps = {
    name: string;
    enabled: boolean;
    id: string;
  };

  const getProfessionTypeById = (id: string) => {
    const professionType: ProfessionTypeProps | undefined =
      authStore.professionTypes.find((profesion) => profesion.id === id);
    return professionType;
  };

  const checkProviderAuthorization = async (
    selected: any,
    host: string,
    lot: string,
    onWithoutResults?: (args?: any) => void
  ) => {
    let isProviderAuthorization = false;
    await user
      .getProvidersAuthorizations(authStore.token, host, lot)
      .then((response) => {
        const providers: any[] = response.data;
        if (providers.length !== 0) {
          setDialogState({
            open: true,
            providers,
            lotName: selected.residencesInfo[0].lotInfo.name,
          });
          isProviderAuthorization = true;
        }
      })
      .finally(() => setLoading(false));
    if (selected && !isProviderAuthorization) {
      if (onWithoutResults) onWithoutResults(selected);
    }
  };
  return {
    loading,
    dialogState,
    checkProviderAuthorization,
    reset,
    getProfessionTypeById,
  };
};

export default useProviderAuthorization;
